/**
 * Presentational loading and error states shared by the data-backed pages, so every page renders a
 * consistent `role="status"` spinner line and a `role="alert"` error panel — including the special
 * "your session expired" prompt for a `401` auth error (surfaced via {@link Resource}'s `isAuthError`).
 */

/** A polite, screen-reader-announced loading line. */
export function LoadingState({ label }: { label: string }): JSX.Element {
  return (
    <p role="status" className="muted">
      {label}
    </p>
  );
}

/**
 * An error panel. When `isAuthError` is set (a `401`), it leads with a re-authentication prompt;
 * otherwise it shows the caller-supplied summary. The underlying message is always shown as detail.
 */
export function ErrorState({
  summary,
  message,
  isAuthError,
}: {
  summary: string;
  message: string;
  isAuthError: boolean;
}): JSX.Element {
  return (
    <div role="alert" className="error-panel">
      <p>{isAuthError ? 'Your session expired. Please sign in again.' : summary}</p>
      <p className="muted">{message}</p>
    </div>
  );
}
